let hash = {};
let query = {};

export const hasher = {
    name: 'hasher',
    store() {
        return {
            hash: {},
             query: {},
            init() {
            },
            setHash(key, value) {
                hash[key] = value;
                return hash;
            },
            getHash(key) {
                return hash[key];
            },
            setQuery(key, value) {
                query[key] = value;
                return query;
            },
            getQuery(key) {
                return query[key];
            }
        }
    }
}
export default hasher;